import { defineMessages } from 'react-intl';

export const insuranceModalMessages = defineMessages({
  title: {
    defaultMessage: 'Insure Shipment',
    id: '6TsUYi',
    description: 'Title of the modal used to edit freight insurance details',
  },
  description: {
    defaultMessage: 'Add protection to this freight shipment in case of loss or damage.',
    id: 'A7XzlV',
    description: 'Descriptive text at the top of the insurance modal',
  },
  conditionOfGoodsLabel: {
    defaultMessage: 'Select Condition of Goods:',
    id: 'QHXE2D',
    description: 'Label above the New/Used radio group in the insurance modal',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: 'Wg5con',
    description: 'Button to close the insurance modal without saving changes',
  },
  save: {
    defaultMessage: 'Save',
    id: 'SVuZfU',
    description: 'Button to save insurance details and close the modal',
  },
  marksAndNumbersPlaceholder: {
    defaultMessage: 'Enter',
    id: 'ihP5Mm',
    description: 'Placeholder for the marks and numbers text input in the insurance modal',
  },
  marksAndNumbersLabel: {
    defaultMessage: 'Marks & Numbers',
    id: 'O2Dn3a',
    description:
      'Label for the marks and numbers text input in the insurance modal (not required, so no asterisk and no "(Optional)" suffix)',
  },
});
